import { RobotVacuumVariantAlertIcon } from './RobotVacuumVariantAlertIcon';

/**
 * author: Michael Irigoyen
 * id DC45B355-D0D4-4616-B1A0-34D22285FE1F
 * name robot-vacuum-variant-alert
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-vacuum-variant-alert.svg
 * tags
 * - Alert / Error 
 * - Home Automation 
 */
export const RobotVacuumVariantErrorIcon = RobotVacuumVariantAlertIcon;
export default RobotVacuumVariantErrorIcon